import _ from 'lodash'

import { Record as AuditRecord, RecolementLinkSchemaResource } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { RecordDataStore as AuditRecordDataStore } from "@skinsoft/entity";
import { CACHE_KEYS, AuditRecordOfflineDataFetcher } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.auditRecord ?? config.syncDownPageSize.default

export class AuditRecordSyncDownHandler extends EntitySyncDownHandler<AuditRecord, AuditRecord, AuditRecord> {
    private static instance: AuditRecordSyncDownHandler = null as any

    public static getInstance() {
        if (!AuditRecordSyncDownHandler.instance) {
            AuditRecordSyncDownHandler.instance = new AuditRecordSyncDownHandler()
        }

        return AuditRecordSyncDownHandler.instance
    }

    public static install(Vue) {
        AuditRecordSyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.auditRecord],
            AuditRecordDataStore.getInstance(),
            new AuditRecordOfflineDataFetcher(),
            CACHE_KEYS.AuditRecord,
            SEARCH_PAGE_SIZE
        )
    }

    formatDataForCachingMapFunction(entity: AuditRecord): AuditRecord {
        if((entity.recolementLinkSchema?.linkedItem as any)?.ref) {
            let formattedEntity = _.cloneDeep(entity)
            let linkedItem: Partial<RecolementLinkSchemaResource['linkedItem']> = {
                linkableItem: (entity.recolementLinkSchema!.linkedItem as any).ref
            }

            if((entity.recolementLinkSchema!.linkedItem as any).referenceType) {
                linkedItem.linkableItemReferenceType = (entity.recolementLinkSchema!.linkedItem as any).referenceType
            }

            _.set(
                formattedEntity,
                'recolementLinkSchema.linkedItem',
                linkedItem
            )

            return super.formatDataForCachingMapFunction(formattedEntity)
        }

        return super.formatDataForCachingMapFunction(entity)
    }
}